import { useEffect, useState } from "react";
import { fetchAdminDashboardData } from "PlatForms/OrgLMS/Services/AdminServices/DashboardService";
import api from "Common/Client/Interceptor";

const useAdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        // The dashboard parent now returns counts/admin/library summary only.
        // The trainings and training-requests lists were moved to separate
        // paginated endpoints, so load them and merge them back in.
        const [data, trainingsRes, requestsRes] = await Promise.all([
          fetchAdminDashboardData(token),
          api.get("/Training/List-For-User", { params: { pageNumber: 1, pageSize: 10 } }),
          api.get("/TrainingRequest/Admin/List", { params: { pageNumber: 1, pageSize: 10 } }),
        ]);
        setDashboardData({
          ...data,
          trainings: trainingsRes.data.items || [],
          trainingRequests: requestsRes.data.items || [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useAdminDashboard;
